"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapMaybe = exports.flatMap = exports.map = void 0;
var piper_1 = require("@kofno/piper");
var map = function (fn) { return function (as) {
    return as.map(fn);
}; };
exports.map = map;
function flatMap(fn, ary) {
    var flatMapImpl = function (ary) {
        var result = [];
        ary.forEach(function (t) { return fn(t).forEach(function (u) { return result.push(u); }); });
        return result;
    };
    return typeof ary === "undefined" ? flatMapImpl : flatMapImpl(ary);
}
exports.flatMap = flatMap;
function mapMaybe(fn, ts) {
    var reducer = function (collection) {
        return collection.reduce(function (accum, t) {
            return fn(t).cata({
                Just: function (value) { return accum.concat([value]); },
                Nothing: piper_1.always(accum)
            });
        }, []);
    };
    return typeof ts === "undefined" ? reducer : reducer(ts);
}
exports.mapMaybe = mapMaybe;
